import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import MalidCard from './MalidCard';

class BinView extends Component {
	render() {
		return (
			<MalidCard title={window.l('bin_title')}
				count={this.props.count}
				visible={(this.props.data && this.props.data.length > 0)}
				frontPage={this.props.frontPage}
				aboutText={window.l('bin_about')}
				database="bin_malid2">
				{
					this.props.data && this.props.data.map(function(item, index) {
						return item.flettur.map((fletta) => <p className="card-text" key={index}><a href={'http://bin.arnastofnun.is/leit/?id='+fletta.id}>{item.lemma}</a> {fletta.kennimyndir && fletta.kennimyndir.length > 0 ? fletta.kennimyndir+', ' : ''}<span dangerouslySetInnerHTML={{__html: fletta.ofl}} /></p>)
					}.bind(this))
				}
			</MalidCard>
		);
	}
}

export default BinView;



// WEBPACK FOOTER //
// ./src/components/BinViewV2.js